import { isEmptyArray } from '../objects/isEmpty';
import { filterBlank } from './filterEmpty';

export function uniqueValues<T>(values: Array<T | undefined | null> | undefined | null): T[] {
	// Filter out any blanks
	const filtered = filterBlank(values);
	if (isEmptyArray(filtered)) {
		return [];
	}

	const unique: Record<string, T> = {};
	for (const value of filtered) {
		const jsonValue = JSON.stringify(value);

		// TODO: handle objects or things that we can't stringify

		unique[jsonValue] = value;
	}

	const result = Object.values(unique);
	return filterBlank(result);
}
